const uris = {
  keys: '/keys',
  profiles: '/usuarios/profile',
  usuarios: '/usuarios',
  usuariosCredentials: '/usuarios/credentials',
  usuariosSendCode: '/usuarios/sendcode',
  usuariosUseCode: '/usuarios/usecode',
  usuariosChangePassword: '/usuarios/changepassword',
  sesiones: '/sesiones',
  sesionesUse: '/sesiones/use',
  sesionesPag: '/sesiones/pag'
}

export default uris
